export function isPatternOwner(
  pattern: { gcid?: string; author?: string },
  usermeta: { gcid: string; email: string }
): boolean {
  if (pattern.gcid) return pattern.gcid === usermeta.gcid
  // Legacy fallback for patterns saved before gcid was set
  return usermeta.email?.split('@')[0] === pattern.author
}
